/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiNurseryManagerOrdersConfirmOrderPost } from '../fn/orders/api-nursery-manager-orders-confirm-order-post';
import { ApiNurseryManagerOrdersConfirmOrderPost$Params } from '../fn/orders/api-nursery-manager-orders-confirm-order-post';
import { apiNurseryManagerOrdersConfirmOrderPost$Plain } from '../fn/orders/api-nursery-manager-orders-confirm-order-post-plain';
import { ApiNurseryManagerOrdersConfirmOrderPost$Plain$Params } from '../fn/orders/api-nursery-manager-orders-confirm-order-post-plain';
import { apiNurseryManagerOrdersCreateOrderPost } from '../fn/orders/api-nursery-manager-orders-create-order-post';
import { ApiNurseryManagerOrdersCreateOrderPost$Params } from '../fn/orders/api-nursery-manager-orders-create-order-post';
import { apiNurseryManagerOrdersCreateOrderPost$Plain } from '../fn/orders/api-nursery-manager-orders-create-order-post-plain';
import { ApiNurseryManagerOrdersCreateOrderPost$Plain$Params } from '../fn/orders/api-nursery-manager-orders-create-order-post-plain';
import { apiNurseryManagerOrdersDeleteOrderDelete } from '../fn/orders/api-nursery-manager-orders-delete-order-delete';
import { ApiNurseryManagerOrdersDeleteOrderDelete$Params } from '../fn/orders/api-nursery-manager-orders-delete-order-delete';
import { apiNurseryManagerOrdersDeleteOrderDelete$Plain } from '../fn/orders/api-nursery-manager-orders-delete-order-delete-plain';
import { ApiNurseryManagerOrdersDeleteOrderDelete$Plain$Params } from '../fn/orders/api-nursery-manager-orders-delete-order-delete-plain';
import { apiNurseryManagerOrdersGetOrderPost } from '../fn/orders/api-nursery-manager-orders-get-order-post';
import { ApiNurseryManagerOrdersGetOrderPost$Params } from '../fn/orders/api-nursery-manager-orders-get-order-post';
import { apiNurseryManagerOrdersGetOrderPost$Plain } from '../fn/orders/api-nursery-manager-orders-get-order-post-plain';
import { ApiNurseryManagerOrdersGetOrderPost$Plain$Params } from '../fn/orders/api-nursery-manager-orders-get-order-post-plain';
import { apiNurseryManagerOrdersGetOrdersPost } from '../fn/orders/api-nursery-manager-orders-get-orders-post';
import { ApiNurseryManagerOrdersGetOrdersPost$Params } from '../fn/orders/api-nursery-manager-orders-get-orders-post';
import { apiNurseryManagerOrdersGetOrdersPost$Plain } from '../fn/orders/api-nursery-manager-orders-get-orders-post-plain';
import { ApiNurseryManagerOrdersGetOrdersPost$Plain$Params } from '../fn/orders/api-nursery-manager-orders-get-orders-post-plain';
import { apiNurseryManagerOrdersOrderApprovePost } from '../fn/orders/api-nursery-manager-orders-order-approve-post';
import { ApiNurseryManagerOrdersOrderApprovePost$Params } from '../fn/orders/api-nursery-manager-orders-order-approve-post';
import { apiNurseryManagerOrdersOrderApprovePost$Plain } from '../fn/orders/api-nursery-manager-orders-order-approve-post-plain';
import { ApiNurseryManagerOrdersOrderApprovePost$Plain$Params } from '../fn/orders/api-nursery-manager-orders-order-approve-post-plain';
import { apiNurseryManagerOrdersUpdateOrderPatch } from '../fn/orders/api-nursery-manager-orders-update-order-patch';
import { ApiNurseryManagerOrdersUpdateOrderPatch$Params } from '../fn/orders/api-nursery-manager-orders-update-order-patch';
import { apiNurseryManagerOrdersUpdateOrderPatch$Plain } from '../fn/orders/api-nursery-manager-orders-update-order-patch-plain';
import { ApiNurseryManagerOrdersUpdateOrderPatch$Plain$Params } from '../fn/orders/api-nursery-manager-orders-update-order-patch-plain';
import { ConfirmOrderCommandResult } from '../models/confirm-order-command-result';
import { CreateOrderCommandResult } from '../models/create-order-command-result';
import { DeleteOrderCommandResult } from '../models/delete-order-command-result';
import { GetOrderQueryResult } from '../models/get-order-query-result';
import { GetOrdersQueryResult } from '../models/get-orders-query-result';
import { OrderApproveCommandResult } from '../models/order-approve-command-result';
import { UpdateOrderCommandResult } from '../models/update-order-command-result';

@Injectable({ providedIn: 'root' })
export class OrdersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiNurseryManagerOrdersGetOrderPost()` */
  static readonly ApiNurseryManagerOrdersGetOrderPostPath = '/api/NurseryManager/Orders/GetOrder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrdersGetOrderPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrdersGetOrderPost$Plain$Response(params?: ApiNurseryManagerOrdersGetOrderPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrderQueryResult>> {
    return apiNurseryManagerOrdersGetOrderPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrdersGetOrderPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrdersGetOrderPost$Plain(params?: ApiNurseryManagerOrdersGetOrderPost$Plain$Params, context?: HttpContext): Observable<GetOrderQueryResult> {
    return this.apiNurseryManagerOrdersGetOrderPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetOrderQueryResult>): GetOrderQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrdersGetOrderPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrdersGetOrderPost$Response(params?: ApiNurseryManagerOrdersGetOrderPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrderQueryResult>> {
    return apiNurseryManagerOrdersGetOrderPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrdersGetOrderPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrdersGetOrderPost(params?: ApiNurseryManagerOrdersGetOrderPost$Params, context?: HttpContext): Observable<GetOrderQueryResult> {
    return this.apiNurseryManagerOrdersGetOrderPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetOrderQueryResult>): GetOrderQueryResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerOrdersGetOrdersPost()` */
  static readonly ApiNurseryManagerOrdersGetOrdersPostPath = '/api/NurseryManager/Orders/GetOrders';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrdersGetOrdersPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrdersGetOrdersPost$Plain$Response(params?: ApiNurseryManagerOrdersGetOrdersPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrdersQueryResult>> {
    return apiNurseryManagerOrdersGetOrdersPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrdersGetOrdersPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrdersGetOrdersPost$Plain(params?: ApiNurseryManagerOrdersGetOrdersPost$Plain$Params, context?: HttpContext): Observable<GetOrdersQueryResult> {
    return this.apiNurseryManagerOrdersGetOrdersPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetOrdersQueryResult>): GetOrdersQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrdersGetOrdersPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrdersGetOrdersPost$Response(params?: ApiNurseryManagerOrdersGetOrdersPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrdersQueryResult>> {
    return apiNurseryManagerOrdersGetOrdersPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrdersGetOrdersPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrdersGetOrdersPost(params?: ApiNurseryManagerOrdersGetOrdersPost$Params, context?: HttpContext): Observable<GetOrdersQueryResult> {
    return this.apiNurseryManagerOrdersGetOrdersPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetOrdersQueryResult>): GetOrdersQueryResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerOrdersCreateOrderPost()` */
  static readonly ApiNurseryManagerOrdersCreateOrderPostPath = '/api/NurseryManager/Orders/CreateOrder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrdersCreateOrderPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrdersCreateOrderPost$Plain$Response(params?: ApiNurseryManagerOrdersCreateOrderPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateOrderCommandResult>> {
    return apiNurseryManagerOrdersCreateOrderPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrdersCreateOrderPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrdersCreateOrderPost$Plain(params?: ApiNurseryManagerOrdersCreateOrderPost$Plain$Params, context?: HttpContext): Observable<CreateOrderCommandResult> {
    return this.apiNurseryManagerOrdersCreateOrderPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateOrderCommandResult>): CreateOrderCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrdersCreateOrderPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrdersCreateOrderPost$Response(params?: ApiNurseryManagerOrdersCreateOrderPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateOrderCommandResult>> {
    return apiNurseryManagerOrdersCreateOrderPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrdersCreateOrderPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrdersCreateOrderPost(params?: ApiNurseryManagerOrdersCreateOrderPost$Params, context?: HttpContext): Observable<CreateOrderCommandResult> {
    return this.apiNurseryManagerOrdersCreateOrderPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateOrderCommandResult>): CreateOrderCommandResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerOrdersOrderApprovePost()` */
  static readonly ApiNurseryManagerOrdersOrderApprovePostPath = '/api/NurseryManager/Orders/OrderApprove';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrdersOrderApprovePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrdersOrderApprovePost$Plain$Response(params?: ApiNurseryManagerOrdersOrderApprovePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<OrderApproveCommandResult>> {
    return apiNurseryManagerOrdersOrderApprovePost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrdersOrderApprovePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrdersOrderApprovePost$Plain(params?: ApiNurseryManagerOrdersOrderApprovePost$Plain$Params, context?: HttpContext): Observable<OrderApproveCommandResult> {
    return this.apiNurseryManagerOrdersOrderApprovePost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<OrderApproveCommandResult>): OrderApproveCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrdersOrderApprovePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrdersOrderApprovePost$Response(params?: ApiNurseryManagerOrdersOrderApprovePost$Params, context?: HttpContext): Observable<StrictHttpResponse<OrderApproveCommandResult>> {
    return apiNurseryManagerOrdersOrderApprovePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrdersOrderApprovePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrdersOrderApprovePost(params?: ApiNurseryManagerOrdersOrderApprovePost$Params, context?: HttpContext): Observable<OrderApproveCommandResult> {
    return this.apiNurseryManagerOrdersOrderApprovePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<OrderApproveCommandResult>): OrderApproveCommandResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerOrdersConfirmOrderPost()` */
  static readonly ApiNurseryManagerOrdersConfirmOrderPostPath = '/api/NurseryManager/Orders/ConfirmOrder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrdersConfirmOrderPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrdersConfirmOrderPost$Plain$Response(params?: ApiNurseryManagerOrdersConfirmOrderPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ConfirmOrderCommandResult>> {
    return apiNurseryManagerOrdersConfirmOrderPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrdersConfirmOrderPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrdersConfirmOrderPost$Plain(params?: ApiNurseryManagerOrdersConfirmOrderPost$Plain$Params, context?: HttpContext): Observable<ConfirmOrderCommandResult> {
    return this.apiNurseryManagerOrdersConfirmOrderPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ConfirmOrderCommandResult>): ConfirmOrderCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrdersConfirmOrderPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrdersConfirmOrderPost$Response(params?: ApiNurseryManagerOrdersConfirmOrderPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ConfirmOrderCommandResult>> {
    return apiNurseryManagerOrdersConfirmOrderPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrdersConfirmOrderPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrdersConfirmOrderPost(params?: ApiNurseryManagerOrdersConfirmOrderPost$Params, context?: HttpContext): Observable<ConfirmOrderCommandResult> {
    return this.apiNurseryManagerOrdersConfirmOrderPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ConfirmOrderCommandResult>): ConfirmOrderCommandResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerOrdersUpdateOrderPatch()` */
  static readonly ApiNurseryManagerOrdersUpdateOrderPatchPath = '/api/NurseryManager/Orders/UpdateOrder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrdersUpdateOrderPatch$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrdersUpdateOrderPatch$Plain$Response(params?: ApiNurseryManagerOrdersUpdateOrderPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateOrderCommandResult>> {
    return apiNurseryManagerOrdersUpdateOrderPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrdersUpdateOrderPatch$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrdersUpdateOrderPatch$Plain(params?: ApiNurseryManagerOrdersUpdateOrderPatch$Plain$Params, context?: HttpContext): Observable<UpdateOrderCommandResult> {
    return this.apiNurseryManagerOrdersUpdateOrderPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateOrderCommandResult>): UpdateOrderCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrdersUpdateOrderPatch()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrdersUpdateOrderPatch$Response(params?: ApiNurseryManagerOrdersUpdateOrderPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateOrderCommandResult>> {
    return apiNurseryManagerOrdersUpdateOrderPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrdersUpdateOrderPatch$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrdersUpdateOrderPatch(params?: ApiNurseryManagerOrdersUpdateOrderPatch$Params, context?: HttpContext): Observable<UpdateOrderCommandResult> {
    return this.apiNurseryManagerOrdersUpdateOrderPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateOrderCommandResult>): UpdateOrderCommandResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerOrdersDeleteOrderDelete()` */
  static readonly ApiNurseryManagerOrdersDeleteOrderDeletePath = '/api/NurseryManager/Orders/DeleteOrder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrdersDeleteOrderDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrdersDeleteOrderDelete$Plain$Response(params?: ApiNurseryManagerOrdersDeleteOrderDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteOrderCommandResult>> {
    return apiNurseryManagerOrdersDeleteOrderDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrdersDeleteOrderDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrdersDeleteOrderDelete$Plain(params?: ApiNurseryManagerOrdersDeleteOrderDelete$Plain$Params, context?: HttpContext): Observable<DeleteOrderCommandResult> {
    return this.apiNurseryManagerOrdersDeleteOrderDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteOrderCommandResult>): DeleteOrderCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerOrdersDeleteOrderDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrdersDeleteOrderDelete$Response(params?: ApiNurseryManagerOrdersDeleteOrderDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteOrderCommandResult>> {
    return apiNurseryManagerOrdersDeleteOrderDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerOrdersDeleteOrderDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerOrdersDeleteOrderDelete(params?: ApiNurseryManagerOrdersDeleteOrderDelete$Params, context?: HttpContext): Observable<DeleteOrderCommandResult> {
    return this.apiNurseryManagerOrdersDeleteOrderDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteOrderCommandResult>): DeleteOrderCommandResult => r.body)
    );
  }

}
